export default "__VITE_ASSET__g92TAb5c__"